import { render, staticRenderFns } from "./ArchiveLocationSidepanel.vue?vue&type=template&id=dce418ac&"
import script from "./ArchiveLocationSidepanel.vue?vue&type=script&lang=js&"
export * from "./ArchiveLocationSidepanel.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveLocationSidepanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports